/* eslint-disable import/no-anonymous-default-export */
import _ from 'lodash';

const initialState = 1;

export default (state = initialState, action) => {

  if (action.type === 'INCREMENT_PAGE_TENABLE') {

    return state + 1;
  }

  if (
    [
      'RESET_PAGE_TENABLE',
      'ADD_FILTER_TENABLE',
      'DELETE_FILTER_TENABLE',
      'RESET_FILTERS_TENABLE',
      'SET_FILTERS_TENABLE',
    ].includes(action.type)
  ) {
    return 1;
  }

  // -----------------------------------------  Reset the state when the user logs out ------------------------------------------
  if (action.type === 'LOGOUT_USER') {
    return initialState;
  }

  return state;
};